import { getTheme } from '@ane/ui-components';
export var QuickValidateStatuses;
(function (QuickValidateStatuses) {
    QuickValidateStatuses["NotStarted"] = "NotStarted";
    QuickValidateStatuses["InProgress"] = "InProgress";
    QuickValidateStatuses["CompiledSuccessfully"] = "CompiledSuccessfully";
    QuickValidateStatuses["Success"] = "Success";
    QuickValidateStatuses["Failed"] = "Failed";
    QuickValidateStatuses["HitMaxRetryCount"] = "HitMaxRetryCount";
    QuickValidateStatuses["NotFound"] = "NotFound";
})(QuickValidateStatuses || (QuickValidateStatuses = {}));
export var QuickCompilationStatuses;
(function (QuickCompilationStatuses) {
    QuickCompilationStatuses["Succeeded"] = "Succeeded";
    QuickCompilationStatuses["Failed"] = "Failed";
    QuickCompilationStatuses["NotStarted"] = "NotStarted";
})(QuickCompilationStatuses || (QuickCompilationStatuses = {}));
export var QuickValidateAPIStatus;
(function (QuickValidateAPIStatus) {
    QuickValidateAPIStatus["Accepted"] = "Accepted";
    QuickValidateAPIStatus["Compiled"] = "Compiled";
    QuickValidateAPIStatus["Submitted"] = "Submitted";
    QuickValidateAPIStatus["Completed"] = "Completed";
    QuickValidateAPIStatus["Failed"] = "Failed";
})(QuickValidateAPIStatus || (QuickValidateAPIStatus = {}));
const theme = getTheme();
export const compileFailedIconProps = {
    ariaLabel: 'Failed',
    iconName: 'Blocked2Solid',
    style: {
        color: theme.palette.red,
        fontSize: theme.fonts.small.fontSize,
        height: theme.fonts.small.fontSize,
        lineHeight: theme.fonts.medium.fontSize,
    },
};
export const compileFailedLinkProps = {
    ariaLabel: 'Failed',
    style: { fontSize: theme.fonts.small.fontSize, height: theme.fonts.medium.fontSize },
};
export const compileSucceededIconProps = {
    ariaLabel: 'Succeeded',
    iconName: 'CompletedSolid',
    style: {
        color: theme.palette.green,
        fontSize: theme.fonts.small.fontSize,
        height: theme.fonts.small.fontSize,
        lineHeight: theme.fonts.medium.fontSize,
    },
};
export const compileSucceededTextProps = {
    style: { fontSize: theme.fonts.small.fontSize, height: theme.fonts.medium.fontSize },
};
export const LoadQuickResultPollInterval = 10 * 1000;
export const LoadQuickResultMaxRetryCount = 60 * 12;
export const quickCompileTitle = 'Compile result';
export const quickPreviewTitle = 'Preview result';
export const loadingQuickResultText = 'Please wait while the metric is being compiled and computed.';
export const loadingComputationText = 'Metric successfully compiled. Awaiting computation. This could take up to 15 minutes...';
export const loadQuickResultErrorPrefix = 'Load quick preview result failed, error:';
export const loadQuickResultExceedMaxRetryText = 'Loading quick preview result hits max retry count, please wait or refresh the page.';
export const putQuickErrorPrefix = 'Quick preview request failed, error:';

//# sourceMappingURL=QuickValidate.constants.js.map
